import OfferingCardBuilder from 'components/OfferingCardBuilder';
import useMobxStores from 'hooks/useMobxStores';
import { observer } from 'mobx-react';
import React from 'react';
import { CatalogEntry } from 'types';
import {
  CourseLvcUserFacingStatus,
  useEntryLiveClassInfo,
} from 'views/Catalog/useCourseLiveClassInfo';

type BaseOfferingCardWithLiveClassProps = {
  className?: string;
  entry?: CatalogEntry;
  isLocked?: boolean;
  isSearch?: boolean;
  hideAllActionButtons?: boolean;
};

const BaseOfferingCardWithLiveClass: React.FC<
  BaseOfferingCardWithLiveClassProps
> = ({ className, entry, isLocked, isSearch, hideAllActionButtons }) => {
  const { userStore } = useMobxStores();
  const { entitlementEnablements } = userStore;
  const lvcInfo = useEntryLiveClassInfo(entry);

  const {
    hasAvailableVLC = false,
    ongoingEnrolledVLC = [],
    attentedEnrolledVLC = [],
    upcomingEnrolledVLC = [],
    courseVlcUserFacingStatus = CourseLvcUserFacingStatus.Unavailable,
    hasEnrolledVLC = false,
  } = lvcInfo ?? {};

  const uuidOnGoingEnrolledLVC = ongoingEnrolledVLC.find(
    (vlcEntry) => vlcEntry.offering_code === entry?.code,
  );

  const quotas = entitlementEnablements?.quotas?.live_class_completed_per_sku;

  return (
    <OfferingCardBuilder
      className={className}
      entry={entry}
      isLocked={isLocked}
      isSearch={isSearch}
      hasLiveVirtualClass={hasAvailableVLC || hasEnrolledVLC}
      lvcStatus={courseVlcUserFacingStatus}
    >
      <OfferingCardBuilder.Header />
      <OfferingCardBuilder.Body
        liveVirtualClassInfo={{
          attentedEnrolledLVC: attentedEnrolledVLC,
          lvcAttended: entry?.code ? quotas?.used?.[entry.code] : undefined,
          lvcQuota: entry?.code
            ? quotas?.allowed?.[entry.code] || quotas?.allowed?.default
            : quotas?.allowed?.default,
          ongoingEnrolledLVC: ongoingEnrolledVLC,
          upcomingEnrolledLVC: upcomingEnrolledVLC,
        }}
      />
      <OfferingCardBuilder.Footer
        hideAllActionButtons={hideAllActionButtons}
        lvcUuid={uuidOnGoingEnrolledLVC?.class_uuid}
      />
    </OfferingCardBuilder>
  );
};

export default observer(BaseOfferingCardWithLiveClass);
